import { Inject, Injectable, InjectionToken } from '@angular/core';
import type { OpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import '@rxap/rxjs';
import { Method } from 'eurogard-pattern';

export const ROW_EDIT_LOADER_SOURCE_METHOD = new InjectionToken('row-edit-loader-source-method');

@Injectable()
export class RowEditLoaderMethod<Data extends Record<string, any>> implements Method {

  constructor(
    @Inject(ROW_EDIT_LOADER_SOURCE_METHOD)
    private readonly sourceMethod: OpenApiRemoteMethod<Data>,
  ) {
  }

  public call(row: { uuid: string }): Promise<Data> {
    return this.sourceMethod.call({parameters: {uuid: row.uuid}});
  }

}
